<template>
  <div class="form-wrapper border-lg shadow pt-6 pb-4 px-7">
    <v-form :ref="setFormRef" @submit.prevent="send">
      <div class="flex items-center gap-3 mb-2">
        <AppIcon icon="heroicons-outline:chat-alt" color="tertiary" size="x-large" />
        <h3 class="mb-0">{{ $tt('contact_page.msg_send') }}</h3>
      </div>
      <p class="mb-4">{{ $tt('contact_page.msg_send_body') }}</p>
      <AppRow unwrapped>
        <AppCol class="pb-0">
          <TextField v-model="name" :label="$tt('full_name')" name="name" :rules="[required]" />
          <EmailField v-model="email" :label="$tt('contact_page.email_address')" />
          <DesktopOnly>
            <ContactFormBtn :loading />
          </DesktopOnly>
        </AppCol>
        <AppCol>
          <TextArea v-model="msg" :label="$tt('contact_page.msg')" name="message" :rules="[required]" rows="5" />
          <MobileOnly>
            <ContactFormBtn :loading />
          </MobileOnly>
        </AppCol>
      </AppRow>
    </v-form>
  </div>
</template>

<script setup lang="ts">
import { sendContactMessage } from '~/helpers/http';

const { required } = useValidation();
const { setFormRef, submit, reset, loading } = useForm();

const name = ref('');
const email = ref('');
const msg = ref('');

function send() {
  submit(async () => {
    const payload = { name: name.value, email: email.value, msg: msg.value };
    await sendContactMessage(payload);
    reset();
  }, { successMsg: 'contact_page.msg_send_success' });
}
</script>

<style scoped>
p {
  line-height: var(--lh-md);
}
h3 {
  font-size: 20px;
}
@media (max-width: 850px) {
  .form-wrapper {
    padding: var(--space-6) var(--space-5) !important;
  }
}
</style>